import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { HubConnection, HubConnectionState } from '@microsoft/signalr';

import { createSignlaRHubConnection, stopAndClearSignalRHubConnection } from '../actions/messagingActions';
import { IState } from '../reducers';

let startPromise: Promise<void> | null = null;
let attachedAccessToken: string | undefined;

export const disposeSignalRConnection = async (
    dispatch: ThunkDispatch<IState, any, AnyAction>
): Promise<void> => {
    attachedAccessToken = undefined;
    startPromise = null;
    await dispatch(stopAndClearSignalRHubConnection());
};

export const ensureSignalRConnection = async (
    dispatch: ThunkDispatch<IState, any, AnyAction>,
    signalRUri: string,
    token: string
): Promise<HubConnection | undefined> => {
    if (!signalRUri || !token) {
        return undefined;
    }

    if (attachedAccessToken && attachedAccessToken !== token) {
        await disposeSignalRConnection(dispatch);
    }

    attachedAccessToken = token;

    const connection = await Promise.resolve(
        dispatch(createSignlaRHubConnection(signalRUri, token))
    ) as HubConnection | undefined;

    if (!connection) {
        return undefined;
    }

    if (connection.state === HubConnectionState.Connected || connection.state === HubConnectionState.Reconnecting) {
        return connection;
    }

    if (connection.state === HubConnectionState.Connecting && startPromise) {
        await startPromise;
        return connection;
    }

    if (connection.state === HubConnectionState.Disconnecting) {
        if (startPromise) {
            await startPromise;
            return connection;
        }
        return connection;
    }

    if (!startPromise) {
        startPromise = connection.start();
    }

    try {
        await startPromise;
    } finally {
        startPromise = null;
    }

    return connection;
};
